




































import { FitHalfScreenDialog, FitButton, FitIcon } from '@tencent/wphk-ui';
import {
  Vue,
  Component,
  Prop,
  Model,
  Watch,
} from 'vue-property-decorator';
import ScrollList from './scrollList.vue';

interface Item {
  label: string;
  value: string;
  children?: Item[];
}

@Component({
  components: {
    FitHalfScreenDialog,
    FitButton,
    ScrollList,
    FitIcon,
  },
})
/**
 * 　value情况测试
 *  1.value空数组
 *  2.value长度大于depth
 *  3.value长度小于depth
 *  4.value长度等于depth
 */
export default class FitMultiPicker extends Vue {
  get multiItems() {
    let { items } = this;
    const outputItems: Item[][] = [];
    for (let i = 0; i < this.depth; i++) {
      if (
        typeof this.curResult[i] !== 'undefined'
        && items[this.curResult[i]]
      ) {
        // 说明能找到值
        outputItems.push(items);
        items = items[this.curResult[i]].children || [];
      } else {
        // 找不到 空数组
        outputItems.push([]);
      }
    }
    return outputItems;
  }
  @Prop() public title!: string;
  @Prop() public isInForm!: boolean;
  @Prop({ default: true }) public maskClose!: boolean;
  @Prop() public confirmBtnText!: string;
  @Prop() public placeholder!: string;
  @Prop({ default: () => [] }) public items!: Item[];
  @Prop({ default: 3 }) public depth!: number;
  @Prop({ default: false }) public disabled!: boolean;
  public visible = false;
  public curLabel = '';
  @Model('change') public readonly value!: string[] | number[];
  public curResult: number[] = [];

  public getValueAndLabelByResult() {
    const value: any = [];
    const label: any = [];
    this.curResult.reduce((pre: Item[], next: number) => {
      const obj = pre[next];
      if (obj) {
        value.push(obj.value);
        label.push(obj.label);
        return obj.children || [];
      }
      return [];
    }, this.items);
    return [value, label];
  }
  onClickPicker() {
    if (!this.disabled) {
      this.visible = true;
    }
  }
  public confirm() {
    const [value, label] = this.getValueAndLabelByResult();
    this.$emit('change', value, label);
    this.onClose();
  }
  public onChange(item: object, index: number, i: number) {
    this.curResult.splice(i, 1, index);
    for (let j = i + 1, l = this.curResult.length; j < l; j++) {
      this.curResult[j] = 0;
    }
  }
  public created() {
    // @ts-ignore
    window.__that = this;
    this.curResult = this.getCurResultByValue();
    this.setLable();
  }
  get isValueAvaliavle() {
    const valueLength = this.value.length;
    if (valueLength === 0) {
      // 数值为空
      return false;
    }
    let tem = this.items;
    for (let i = 0, l = valueLength; i < l; i++) {
      if (!Array.isArray(tem)) {
        // 说明有数值 但是没有匹配了
        return false;
      }
      const resultIndex = tem.findIndex(item => item.value === this.value[i]);

      if (resultIndex === -1) {
        return false;
      }
      tem = tem[resultIndex].children as Item[];
    }
    if (valueLength < this.depth) {
      // 如果数值小于深度 还要判断是否还有子项 没有子项为true 有为false
      return !tem;
    }
    return true;
  }

  public getCurResultByValue() {
    if (!this.isValueAvaliavle) {
      return new Array(this.depth).fill(0);
    }
    const result: number[] = [];
    let tem = this.items;
    for (let i = 0; i < this.depth; i++) {
      const resultIndex = tem.findIndex(item => item.value === this.value[i]);
      if (resultIndex === -1) {
        return result;
      }
      tem = tem[resultIndex].children || [];
      result.push(resultIndex);
    }
    return result;
  }

  @Watch('visible')
  public onValueChange() {
    if (this.visible) {
      this.curResult = this.getCurResultByValue();
    }
  }
  @Watch('items')
  @Watch('value')
  public setLable() {
    if (this.isValueAvaliavle) {
      // const  [value, label] = this.getValueAndLabelByResult();
      // this.curLabel = label.join(',');
      this.curLabel = this.getLabel(this.value, this.items);
      return;
    }
    this.curLabel = '';
  }

  public getLabel(value, items) {
    const label: string[] = [];
    let itemList = items;
    for (let i = 0, l = value.length; i < l; i++) {
      const curValue = value[i];
      const curItem = itemList.find(item => item.value === curValue);
      if (curItem) {
        label.push(curItem.label);
        itemList = curItem.children || [];
      } else {
        return '';
      }
    }
    return label.join(',');
  }

  public onClose() {
    this.$emit('onClose');
    this.visible = false;
  }
}
